import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const base = `${process.env.REACT_APP_API_HOST}/${apiConstants.REPORTS}`;

// The projection and what actually happened, in one call. Editing a cell or
// entering a month returns the saved row, so the page never has to guess
// what the server did with it.
export const getReport = async () => (await axios.get(base)).data;
export const saveProjection = async (segment, horizon, body) => (await axios.put(`${base}/projections/${segment}/${horizon}`, body)).data;
export const saveActual = async (segment, month, body) => (await axios.put(`${base}/actuals/${segment}/${month}`, body)).data;
